import { DEFAULT_ERROR } from '@/constants/errors';
import { MultiFetchDataState } from '@/types/fetchDataState';
import { BioEntityContentsState, SearchBioEntityDataState } from './bioEntity.types';

export const BIO_ENTITY_FETCHING_ERROR_PREFIX = 'Failed to fetch bio entity';

export const MULTI_BIO_ENTITY_FETCHING_ERROR_PREFIX = 'Failed to fetch multi bio entity';

export const BIOENTITY_SEARCH_INITIAL_STATE: MultiFetchDataState<SearchBioEntityDataState[]> = {
  data: [],
  loading: 'idle',
  error: DEFAULT_ERROR,
};

export const BIOENTITY_INITIAL_STATE: BioEntityContentsState = {
  isContentTabOpened: false,
  search: {
    ...BIOENTITY_SEARCH_INITIAL_STATE,
  },
  searchedModelElementsIds: [],
  searchedReactionsIds: [],
};
